import React from "react";
import SubscribersContainer from "../../containers/subscribers/index";
// import ImpactContainer from "../../containers/impacts/Impact";
import { useParams } from "react-router-dom";

const SubscribersPage = () => {
  let { id } = useParams();

  return id ? <SubscribersContainer id={id}/> : <SubscribersContainer/>
};

export default SubscribersPage;
